import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    INBOX_REQUEST,
    INBOX_SUCCESS,
    INBOX_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const InboxAction = (data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_FB_BOT}/api/messages/reply`,
        method: 'POST',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            INBOX_REQUEST,
            {
                type: INBOX_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": INBOX_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: INBOX_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": INBOX_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {InboxAction}